<template>
  <el-container class="energy-price" direction="vertical">
    <common-panel :panel-data="panelData"/>
  </el-container>
</template>

<script>
import CommonPanel from "../../common/panel/CommonPanel";

export default {
  name: "CarbonLimit",
  components: {CommonPanel},
  data() {
    return {
      panelData: {
        tableTitle: '碳排放配额列表',
        hasTree: false,
        hasTreeToolbar: false,
        queryMethod: this.$api.systemManage.getSiteCarbonLimit,
        filterForm: [
          {label: '站点名称：', prop: 'siteName', type: 'input', value: '', style: 'width: 160px;margin-right: 10px;'},
          {label: '年份：', prop: 'limitYear', type: 'year', value: new Date().Format('yyyy'), style: 'width: 160px;margin-right: 10px;'}
        ],
        buttons: [
          {label: '设置配额', icon: 'zy-icon-setting-gear', type: 'updateRows', handleIndex: 1}
        ],
        methods: {
          edit: this.$api.systemManage.updateSiteCarbonLimit,
          update_prop: 'id'
        },
        tableCheck: true,
        tableProps: [
          {prop: "siteName", label: "站点名称"},
          {prop: "carbonLimit", label: "碳排放配额(t)"},
          {prop: "limitYear", label: "年份"}
        ],
        drawerTitle: '配额信息',
        dialogs: {
          add_edit: {
            title: '配额信息',
            width: '700px',
            items: [
              {type: 'input', prop: 'carbonLimit', label: '碳排放配额：', placeholder: '请输入碳排放配额', style: 'width: 315px;'},
              {type: 'year', prop: 'limitYear', label: '年份：', value: new Date().Format('yyyy'), placeholder: '请选择年份', style: 'width: 315px;'}
            ],
            rules: {
              carbonLimit: [
                {required: true, message: '请输入碳排放配额', trigger: 'blur'}
              ],
              limitYear: [
                {required: true, message: '请选择年份', trigger: 'blur'}
              ]
            },
            confirmMethod: null
          }
        }
      }
    }
  }
}
</script>

<style scoped>
  .energy-price{
    width: 100%;
    height: 100%;
  }
  .el-menu{
    background: white;
  }
  .el-menu .el-menu-item{
    font-size: 16px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/SystemSetting/CarbonLimit.vue